import { BaseModel } from "./BaseModel";

export class Org extends BaseModel {
  schema = "/org";
  constructor(params = {}) {
    return super(params, "/org");
  }
}
